'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * it-footer-cell
 * On rend accesible dans le scope du template 'footerValue' et footerValues'
 */
ngModule.directive('itFooterCell', function () {
  return {
    restrict: "A",
    require: "^infiniTable",
    scope: false,
    link: function link($scope, $el, $attrs, tableCtrl) {
      var column = $scope.column;
      if (column.footer) {
        var setFooterValue = function setFooterValue(footerValues) {
          $scope.footerValue = footerValues ? footerValues[column.id] : undefined;
          // on met aussi l'ensemble des values des autres colonnes de total accessibles

          // on reconverti en tableau car footerValues est un objet et cela le rend compliqué à accéder sinon.
          var result = [];
          Object.keys(footerValues).forEach(function (key) {
            result[key] = footerValues[key];
          });
          $scope.footerValues = result;
        };

        // initial set before watch to be on time for initial column width computation
        setFooterValue(tableCtrl.getContext().footerValues);
        $scope.$watch(function () {
          return tableCtrl.getContext().footerValues;
        }, setFooterValue);
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/standard/itFooterCell.js
// module id = 2812
// module chunks = 13